import React, { useEffect } from 'react';
import ProjectNewPhoto from '../images/ProjectNew.png';
import ProjectDemoPhoto from '../images/ProjectDemo.png';
import ProjectSavePhoto from '../images/ProjectSave.png';
import ProjectUploadPhoto from '../images/ProjectUpload.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const ProjectPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Project
        </div>
        <div style={{ margin: '10px 0px' }}>
        Project file is saved as JSON text format. It can be edit with any text editor. 
        </div>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        New Project
        </div>
        <div style={{ margin: '10px 0px' }}>
        To create a new project, click New button in project panel. 
        </div>

        <StyledContainer>
            <img src={ProjectNewPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>


        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Demo Project
        </div>
        <div style={{ margin: '10px 0px' }}>
        To display demo project, click Demo Project button in project panel. 
        </div>

        <StyledContainer>
            <img src={ProjectDemoPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Save Project
        </div>
        <div style={{ margin: '10px 0px' }}>
        To save the project, click Save button in project panel. Project named project.json will be saved to the download folder. 
        </div>

        <StyledContainer>
            <img src={ProjectSavePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Open Project
        </div>
        <div style={{ margin: '10px 0px' }}>
        To open the saved project, click Open button in project panel. In Open Project dialog, 
        click Choose File button to select your project file, then click OK button.
        </div>

        <StyledContainer>
            <img src={ProjectUploadPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default ProjectPage;